'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _KeyboardHoverOnlyDiv = require('../utils/KeyboardHoverOnlyDiv');

var _KeyboardHoverOnlyDiv2 = _interopRequireDefault(_KeyboardHoverOnlyDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FloatingActionButton = function FloatingActionButton(props) {
  var _ClassNames;

  var _props$kind = props.kind,
      kind = _props$kind === undefined ? 'primary' : _props$kind,
      _props$size = props.size,
      size = _props$size === undefined ? 'lg' : _props$size,
      _props$disabled = props.disabled,
      disabled = _props$disabled === undefined ? false : _props$disabled,
      children = props.children,
      style = props.style,
      className = props.className,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === undefined ? false : _props$isLoading,
      _props$isLoadingBlock = props.isLoadingBlocking,
      isLoadingBlocking = _props$isLoadingBlock === undefined ? true : _props$isLoadingBlock,
      onMouseDown = props.onMouseDown,
      onBlur = props.onBlur,
      other = _objectWithoutProperties(props, ['kind', 'size', 'disabled', 'children', 'style', 'className', 'isLoading', 'isLoadingBlocking', 'onMouseDown', 'onBlur']);

  var classes = void 0;
  classes = (0, _classnames2.default)(className, 'a-btn-floating', 'a-btn-floating-' + kind, (_ClassNames = {}, _defineProperty(_ClassNames, 'a-btn-floating-' + size, size !== 'lg'), _defineProperty(_ClassNames, 'a-btn-no-interaction', isLoading), _ClassNames));

  return React.createElement(
    _KeyboardHoverOnlyDiv2.default,
    Object.assign({
      isButton: true,
      style: style,
      className: classes,
      disabled: disabled,
      isLoading: isLoading,
      isLoadingBlocking: isLoadingBlocking
    }, other),
    isLoading ? React.createElement('div', { className: 'a-loading-one' }) : children
  );
};

FloatingActionButton.propTypes = {
  kind: _propTypes2.default.oneOf(['primary', 'secondary', 'gray', 'negative']),
  isLoading: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['sm', 'lg']),
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};

exports.default = FloatingActionButton;